export default __webpack_public_path__ + "src/_images/Visa_Logo.png";